import { getRolesKey, useCreateRole } from 'api-hooks/role';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import RoleForm from './components/form';

export type RoleCreateParams = null;

export default function RoleCreate(
  props: NavigationProps<NavigationRoutes.RolesCreate>,
) {
  const { navigate, back } = useNavigation();

  const { mutateAsync, error } = useCreateRole();
  const permission = useGetCrudPermission('roles');
  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <RoleForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          queryClient.refetchQueries([getRolesKey()[0]]);

          const prevPath = PreviousNavigation.get();
          if (prevPath) {
            PreviousNavigation.remove();
            back();
          } else if (permission.view) {
            navigate(NavigationRoutes.RolesView, {
              id: result.data?.id,
            });
          }

          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
